import _styled from "styled-components";
import { useEffect, useState } from 'react';
import { PhotoIcon } from '@heroicons/react/24/solid';
import { jsx as _jsx } from "react/jsx-runtime";
export var Avatar = function Avatar(_ref) {
  var src = _ref.src,
      firstName = _ref.firstName,
      lastName = _ref.lastName,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? 'md' : _ref$size,
      _ref$alt = _ref.alt,
      alt = _ref$alt === void 0 ? '' : _ref$alt;

  var _useState = useState(false),
      imgFailed = _useState[0],
      setImgFailed = _useState[1]; // Reset error state whenever the image source changes, otherwise switching
  // between candidates with the same Avatar instance can leave us stuck on
  // the initials fallback for a perfectly valid new URL.


  useEffect(function () {
    setImgFailed(false);
  }, [src]);
  var initials = getInitials(firstName, lastName);
  return /*#__PURE__*/_jsx(Wrapper, {
    size: size,
    children: src && !imgFailed ? /*#__PURE__*/_jsx(Img, {
      src: src,
      alt: alt,
      onError: function onError() {
        return setImgFailed(true);
      }
    }) : initials ? /*#__PURE__*/_jsx(Initials, {
      size: size,
      children: initials
    }) : /*#__PURE__*/_jsx(_StyledPhotoIcon, {
      className: size === 'lg' ? 'h-12 w-12' : 'h-6 w-6'
    })
  });
};
export default Avatar;

function getInitials(firstName, lastName) {
  var first = firstLetter(firstName);
  var last = firstLetter(lastName);
  var combined = "".concat(first).concat(last);
  return combined.length > 0 ? combined.toUpperCase() : null;
}

function firstLetter(value) {
  if (!value) return '';
  var stripped = value.normalize('NFD').replace(/[̀-ͯ]/g, '').trim();
  return stripped.charAt(0);
}

var sizeStyles = {
  md: {
    "height": "4rem",
    "width": "4rem"
  },
  lg: {
    "height": "88px",
    "width": "88px"
  }
};
var initialsSizeStyles = {
  md: {
    "fontSize": "1.25rem",
    "lineHeight": "1.75rem"
  },
  lg: {
    "fontSize": "1.875rem",
    "lineHeight": "2.25rem"
  }
};

var Wrapper = /*#__PURE__*/_styled.div.withConfig({
  displayName: "avatar__Wrapper",
  componentId: "sc-1sezkwu-0"
})(["", " ", ""], {
  "position": "relative",
  "display": "grid",
  "placeItems": "center",
  "overflow": "hidden",
  "borderRadius": "0.5rem",
  "--tw-bg-opacity": "1",
  "backgroundColor": "rgb(240 235 248 / var(--tw-bg-opacity))"
}, function (_ref2) {
  var size = _ref2.size;
  return sizeStyles[size];
});

var Img = /*#__PURE__*/_styled.img.withConfig({
  displayName: "avatar__Img",
  componentId: "sc-1sezkwu-1"
})(["", ""], {
  "position": "absolute",
  "top": "0px",
  "right": "0px",
  "bottom": "0px",
  "left": "0px",
  "height": "100%",
  "width": "100%",
  "objectFit": "cover",
  "objectPosition": "center"
});

var Initials = /*#__PURE__*/_styled.span.withConfig({
  displayName: "avatar__Initials",
  componentId: "sc-1sezkwu-2"
})(["", " ", ""], {
  "userSelect": "none",
  "fontWeight": "600",
  "--tw-text-opacity": "1",
  "color": "rgb(72 36 133 / var(--tw-text-opacity))"
}, function (_ref3) {
  var size = _ref3.size;
  return initialsSizeStyles[size];
});

var _StyledPhotoIcon = /*#__PURE__*/_styled(PhotoIcon).withConfig({
  displayName: "avatar___StyledPhotoIcon",
  componentId: "sc-1sezkwu-3"
})({
  "fill": "#482485"
});